export default __webpack_public_path__ + "static/media/DefaultLicense.de42fe63.svg";